import icon from "assets/img/icons/welcome-220k.svg";
import useActiveItem from "hooks/useActiveItem";
import { useSoundPath } from "hooks/useSoundPath";
import { createAPI } from "services/api/api";

const ClaimPrizeSteps = ({
  step,
  setStep,
  isLoading,
  setIsLoading,
  close,
}) => {
  const api = createAPI();
  const {activeItem} = useActiveItem();
  const playSound = useSoundPath();



  const getData = () => {
    if (step === "start") {
      return {
        icon,
        title: "Prediction Resolved True - Claim",
        description:
          "Your Identity and Prize Cards will be sent to your Inventory, and the Prediction Card will be burned",
      };
    } else if (step === "success") {
      return {
        icon,
        title: "Identity and Prize Card sent to inventory!",
        description:
          "Your Identity Card stats have been updated. Your prize card is now redeemable.",
      };
    }
  };

  const confirmRequest = async () => {
    playSound('main');
    await api.post("claimback/cards", {
      nft_card_prediction_id: activeItem.id
    })
    .then(() => {
      setStep("success");
      setIsLoading(false);
    })
    .catch((error) => {
      console.log(error);
      setStep("fail");
      setIsLoading(false);
    })
  };


  return (
    <>
      <header className="modal-window__header">
        <img src={getData().icon} className="modal-window__icon" alt="" />
        <h5 className="modal-window__title">{getData().title}</h5>
        <p className="modal-window__info">{getData().description}</p>
      </header>
      <footer className="modal-window__footer">
        {step === "start" ?
          <>
            <button className="modal-window__footer-close" onClick={close}>
              Cancel
            </button>
            <button
              className={`modal-window__footer-submit ${
                isLoading ? "loading" : ""
              }`}
              disabled={isLoading}
              onClick={confirmRequest}
            >
              Confirm
            </button>
          </>
        :
        <button className="modal-window__footer-close" onClick={close}>Done</button>
        }
      </footer>
    </>
  );
};

export default ClaimPrizeSteps;
